import { Flex, Spin } from "antd";
import clsx from "clsx";

import s from "./Loading.module.css";

interface LoadingProps {
  className?: string;
  isContained?: boolean;
  isFullScreen?: boolean;
  size?: "small" | "large" | "medium";
  tip?: string;
}

const SPIN_SIZE_MAP = {
  small: "small",
  medium: "default",
  large: "large",
} as const satisfies Record<
  NonNullable<LoadingProps["size"]>,
  "small" | "default" | "large"
>;

export const Loading = ({
  isFullScreen,
  size = "small",
  tip,
  isContained,
  className,
}: LoadingProps) => {
  return (
    <Flex
      align="center"
      gap="middle"
      justify={isContained ? "center" : "flex-start"}
      className={clsx(isContained && s.loadingContainer, className)}
    >
      <Spin
        fullscreen={isFullScreen}
        size={SPIN_SIZE_MAP[size]}
        data-testid="loading"
        tip={tip}
      />
    </Flex>
  );
};
